// This is the main entry point for webpack.
// It should include the main resources to be webpack-ed, specific to this application.

// Application custom style
// import "./sass/application.scss"

let Helper = require('./js/helper.js')
let Redirect = require('./js/redirect.js')

module.exports = {
   // Modules to expose to the application pages
   jQuery,
   Helper,
   Redirect,
   // Hook to allow triggering actions on page load
   onDocumentReady: (callback) => { $(document).ready(callback) },
}
